module.exports = __webpack_public_path__ + "img/amazon.de-logo.9d769d13.svg";